/// <reference types="@angular/localize" />

import { importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AuthCoreModule } from '@ortho-next/auth-core';
import { provideScReCaptchaSettings } from '@semantic-components/re-captcha';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { getAuthConfig } from './app/auth.config';
import { APP_CONFIG, AppConfig } from './app/core';


fetch('./config.json')
	.then((response: Response) => {
		if (response.ok) {
			return response.json();
		} else {
			throw new Error('Config file loading error...');
		}
	}).then((config: AppConfig) => {
		bootstrapApplication(AppComponent, {
			providers: [
				{ provide: APP_CONFIG, useValue: config },
				importProvidersFrom(AuthCoreModule.forRoot(getAuthConfig(config))),
				provideScReCaptchaSettings({ v3SiteKey: config.recaptchaSiteKey }),
				...appConfig.providers
			],
		}).catch((err) => console.error(err));
	}).catch((err) => console.error(err));
	